var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.12663 13.9745L3.18742 10.463C2.98501 10.3192 2.93942 10.0411 3.08566 9.84203C3.17065 9.72626 3.30695 9.65763 3.45209 9.65763H9.58592L11.5714 3.80405C11.6505 3.5711 11.9065 3.44523 12.1434 3.52299C12.2781 3.56719 12.384 3.67134 12.429 3.80394L14.4163 9.65763H20.5479C20.7976 9.65763 21 9.8568 21 10.1025C21 10.2453 20.9304 10.3794 20.8127 10.463L15.8734 13.9745L17.8854 19.9138C17.9644 20.1469 17.8364 20.3988 17.5995 20.4765C17.4615 20.5217 17.3098 20.4989 17.1918 20.4151L12.002 16.7269L6.80784 20.4158C6.60542 20.5596 6.32288 20.5147 6.17675 20.3155C6.09155 20.1995 6.06837 20.0503 6.11439 19.9145L8.12663 13.9745Z",
  stroke: "#CCE3F0",
  strokeWidth: 2
})));
export default SvgStar;